<template>
  <div class="setting-container">
    <!-- 头部标题 -->
    <div class="setting-header">
      <h2 class="page-title">账户设置</h2>
    </div>

    <!-- 主体信息：左右两栏 -->
    <div class="info-panels">
      <!-- 左侧面板 -->
      <div id="left_panel" class="panel">
        <div class="field">
          <span class="field-title">实体类型：</span>
          <span class="field-value">{{ getOrgTypeStr(registerInfoForm.org_type) }}
            <button class="btn-primary" @click="change_register_info">资质变更</button>
          </span>          
        </div>
        <div class="field">
          <span class="field-title">{{ GetOrgLabel(registerInfoForm.org_type, 'name') }}：</span>
          <span class="field-value">{{ registerInfoForm.company_name }}</span>
        </div>
        <div class="field">
          <span class="field-title">{{ GetOrgLabel(registerInfoForm.org_type, 'code') }}：</span>
          <span class="field-value">{{ registerInfoForm.social_credit_code }}</span>
        </div>
        <div class="field">
          <span class="field-title">租户管理员姓名：</span>
          <span class="field-value">{{ registerInfoForm.contact_person }}</span>
             <button class="btn-primary" style="margin-left: 10px;" @click="open_admin_name_setting=true">设置</button>
        </div>
        <div class="field">
          <span class="field-title">租户管理员手机号：</span>
          <span class="field-value">{{ registerInfoForm.contact_phone }}（登录用户名）</span>
            <button class="btn-primary" style="margin-left: 10px;" @click="change_admin">变更管理员</button>    
        </div>
        <div class="field">
          <span class="field-title">AI客服应用场景：</span>
          <span class="field-value">{{ registerInfoForm.aics_usage }}</span>
          <button class="btn-primary" style="margin-left: 10px;" @click="open_aics_usage=true">设置</button>
        </div>
      </div>

      <!-- 右侧面板 -->
      <div id="right_panel" class="panel">
        <div style="font-family: 微软雅黑;font-size:14px;">
          <span class="field-title">{{ GetOrgLabel(registerInfoForm.org_type, 'pic') }}：</span>
        </div>
        <div class="field">
          <img :src="registerInfoForm.license_url" style="width: 100%; max-width: 300px;" />
        </div>
        <div class="field">
          <span class="field-title">企业邮箱：</span>
          <span class="field-value">{{ registerInfoForm.company_email }}</span>
          <button class="btn-primary" style="margin-left: 10px;" @click="open_admin_email_setting=true">设置</button>
        </div>
        <div class="field">
          <span class="field-title">注册时间：</span>
          <span class="field-value">{{ formatTime(registerInfoForm.created_at) }}</span>
        </div>
        <div class="field">
          <span class="field-title">平台审核时间：</span>
          <span class="field-value">{{ formatDateTime(registerInfoForm.approved_time) }}</span>
        </div>
      </div>
    </div>

    <!-- 底部面板：发票信息 -->
    <div id="bottom_panel" class="bottom-panel">
      <el-divider content-position="left">发票信息（用于开具增值税专用发票）</el-divider>
      <div class="invoice-grid">
        <div class="field">
          <span class="field-title">开户行：</span>
          <span class="field-value">{{ registerInfoForm.bank_name }}</span>
        </div>
        <div class="field">
          <span class="field-title">银行账号：</span>
          <span class="field-value">{{ registerInfoForm.bank_account }}</span>
        </div>
        <div class="field">
          <span class="field-title">注册地址：</span>
          <span class="field-value">{{ registerInfoForm.reg_address }}</span>
        </div>
        <div class="field">
          <span class="field-title">企业电话：</span>
          <span class="field-value">{{ registerInfoForm.company_phone }}</span>
           <button class="btn-primary" style="margin-left: 10px;" @click="open_invoice_related_setting=true">设置发票相关信息</button>
        </div>
      </div>
    </div>

    <!-- 变更资质对话框 -->
 <el-dialog title="资质变更" :visible.sync="open_change_register_info" width="1124px" append-to-body @close="handleDialogClose">
  <el-form ref="register_info_changeFormRef" :model="register_info_changeForm" label-width="150px">
    <el-row :gutter="10" class="mb8">
      <el-col :span="12">
        <el-form-item label="实体类型">
  <div style="position:relative;">
    <select 
      v-model="registerInfoForm.org_type"
      @change="HandleOrgTypeChange($event.target.value)"
      style="width:100%;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 30px 0 15px;background:#fff;appearance:none;-webkit-appearance:none;font-size:14px;color:#606266;cursor:pointer;"
    >
      <option value="" disabled>请选择实体类型</option>
      <option :value="1">企业</option>
      <option :value="2">个体工商户</option>
      <option :value="3">政府与事业单位</option>
      <option :value="4">社会组织</option>
      <option :value="5">个人开发者/创作者</option>
    </select>
    <!-- 模拟下拉箭头 -->
    <i style="position:absolute;right:10px;top:50%;transform:translateY(-50%);color:#C0C4CC;pointer-events:none;">
      <svg t="1791100603892" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1653" width="16" height="16"><path d="M573.056 752l308.8-404.608A76.8 76.8 0 0 0 820.736 224H203.232a76.8 76.8 0 0 0-61.056 123.392l308.8 404.608a76.8 76.8 0 0 0 122.08 0z" fill="#000000" p-id="1654"></path></svg>
    </i>
  </div>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item :label="labelOrgNameText" prop="company_name">
  <input    
    key="edit-company_name"
    type="text"
    v-model="register_info_changeForm.company_name"
                style="width:100%;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:14px;color:#606266;outline:none;box-sizing:border-box;"
                @focus="$event.target.style.borderColor='#409EFF'"
                @blur="$event.target.style.borderColor='#DCDFE6'"
              />
        </el-form-item>
      </el-col>
    </el-row>                                                                              
    <el-row :gutter="10" class="mb8">
      <el-col :span="12">
<el-form-item
  :label="labelOrgCodeText"
  prop="social_credit_code"
  :class="{'changed_label': register_info_changeForm.social_credit_code !== (registerInfoForm?.social_credit_code || '')}"
> 
  <input    
    key="edit-social_credit_code"
    type="text"
    v-model="register_info_changeForm.social_credit_code"
                      style="width:100%;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:14px;color:#606266;outline:none;box-sizing:border-box;"
                      @focus="$event.target.style.borderColor='#409EFF'"
                      @blur="$event.target.style.borderColor='#DCDFE6'"
                    />
        </el-form-item>
      </el-col>

    </el-row>
      <el-row :gutter="10" class="mb8">
        <el-col :span="24">
          <el-form-item :label="labelOrgPicText">
            <LicenceUploader
              ref="licenceUploader"
              :value="registerInfoForm.license_url"
              mode="edit"
              @file-change="onLicenceFileChange"
            />
          </el-form-item>
        </el-col>
      </el-row>  
      <el-row :gutter="10" class="mb8">
        <el-col :span="24" style="text-align: right;">
            <el-button type="primary" @click="submitregister_info_changeForm">提交</el-button>
            <el-button type  = "normal" @click="refreshPage">取消</el-button>
        </el-col>
      </el-row>
  </el-form>
</el-dialog>    

  <!-- 设置租户管理员姓名对话框 -->
 <el-dialog title="设置租户管理员姓名" :visible.sync="open_admin_name_setting" width="500px" append-to-body @close="open_admin_name_setting= false">
  <el-form ref="register_info_changeFormRef" :model="register_info_changeForm" label-width="150px">
    <el-row :gutter="10" class="mb8">
      <el-col :span="24">
         <input 
         style="width:  100%; background-color: #fff; border: 1px solid #888888;   border-radius: 5px 5px 0 0 !important; height:25px; line-height: 25px;margin-bottom: 10px;"
          v-model="registerInfoForm.contact_person"         
          maxlength="64"        
        />
      </el-col>
    </el-row>                                                                              

      <el-row :gutter="10" class="mb8">
        <el-col :span="24" style="text-align: right;">
            <el-button type="primary" @click="submit_admin_name">提交</el-button>
            <el-button type  = "normal" @click="refreshPage">取消</el-button>
        </el-col>
      </el-row>
  </el-form>
</el-dialog>   

    <!-- 变更管理员对话框 -->
    <el-dialog
      title="变更管理员"
      :visible.sync="dialogChangeAdminVisible"
      width="720px"
      @closed="handleChangeAdminDialogClose">
      <el-form ref="changeAdminForm" :model="changeAdminForm" label-width="100px">
        <div class="form-group">
            <el-row :gutter="10" class="mb8">
              <el-col :span="12">
                <el-form-item label="原手机号" prop="username">
                    <input    
                      key="edit-username"
                      type="text"
                      v-model="changeAdminForm.username"
                      readonly
                      id="username"
                      style="width:260px;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:14px;color:#606266;outline:none;box-sizing:border-box;"
                      @focus="$event.target.style.borderColor='#409EFF'"
                      @blur="$event.target.style.borderColor='#DCDFE6'"
                      />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="验证码" prop="code1">
                    <input    
                      key="edit-code1"
                      type="text"
                      v-model="changeAdminForm.code1" id="code1" 
                      placeholder="原手机验证码"
                      style="width:160px;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:16pt;color:#606266;outline:none;box-sizing:border-box;"
                      @focus="$event.target.style.borderColor='#409EFF'"
                      @blur="$event.target.style.borderColor='#DCDFE6'"
                      />
                </el-form-item>
              </el-col>
            </el-row> 
            <el-row :gutter="10" class="mb8">
            <el-col :span="12">
              <el-form-item label="新手机号" prop="username">
                  <input    
                    key="edit-company_username"
                    type="text"
                    v-model="changeAdminForm.newPhone"        
                    style="width:260px;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:14px;color:#606266;outline:none;box-sizing:border-box;"
                    @focus="$event.target.style.borderColor='#409EFF'"
                    @blur="$event.target.style.borderColor='#DCDFE6'"
                    />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="验证码" prop="code1">
                  <input    
                    key="edit-code1"
                    type="text"
                    v-model="changeAdminForm.code2" id="code2" 
                    placeholder="新手机验证码"
                    style="width:160px;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:16pt;color:#606266;outline:none;box-sizing:border-box;"
                    @focus="$event.target.style.borderColor='#409EFF'"
                    @blur="$event.target.style.borderColor='#DCDFE6'"
                    />
              </el-form-item>
            </el-col>
            </el-row>               
            <el-row :gutter="10" class="mb8">
            <el-col :span="24">
              <el-form-item label="新管理员姓名" prop="username">
                  <input    
                    key="edit-new_adminname"
                    type="text"
                     v-model="changeAdminForm.newName" 
                     id="newName"
                    style="width:260px;height:40px;border:1px solid #DCDFE6;border-radius:4px;padding:0 15px;font-size:14px;color:#606266;outline:none;box-sizing:border-box;"
                    @focus="$event.target.style.borderColor='#409EFF'"
                    @blur="$event.target.style.borderColor='#DCDFE6'"
                    />
              </el-form-item>
            </el-col>
            </el-row>
            </div>                  
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="text" @click="sendSMSCode_change_admin"
        :disabled="isCountingDown || !isPhoneValid"
        >
      
                <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
    <span v-else>
      <i class="el-icon-loading"></i> 发送中...
    </span>
      </el-button>
      <el-button type="primary" @click="handleChangeAdminSubmit">
          <span v-if="!loading_changeAdmin_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
        <el-button n @click="refreshPage">取消</el-button>
      </span>  
    </el-dialog>

  <!-- 设置AI客服应用场景对话框 -->
 <el-dialog title="设置AI客服应用场景" :visible.sync="open_aics_usage" width="1124px" append-to-body @close="open_aics_usage= false">
  <el-form ref="register_info_changeFormRef" :model="register_info_changeForm" label-width="150px">
    <el-row :gutter="10" class="mb8">
      <el-col :span="24">
         <textarea 
         style="width:  100%; background-color: #fff;   border-radius: 12px 12px 0 0 !important;"
          v-model=" registerInfoForm.aics_usage"     
          :placeholder="placeholderText"
          maxlength="1100"
          rows="3"
        ></textarea>
      </el-col>
    </el-row>                                                                              

      <el-row :gutter="10" class="mb8">
        <el-col :span="24" style="text-align: right;">
            <el-button type="primary" @click="submit_aics_usage">提交</el-button>
            <el-button type  = "normal" @click="refreshPage">取消</el-button>
        </el-col>
      </el-row>
  </el-form>
</el-dialog>  

  <!-- 设置企业邮箱对话框 -->
 <el-dialog title="设置企业邮箱" :visible.sync="open_admin_email_setting" width="500px" append-to-body @close="open_admin_name_setting= false">
  <el-form ref="register_info_changeFormRef" :model="register_info_changeForm" label-width="150px">
    <el-row :gutter="10" class="mb8">
      <el-col :span="24">
         <input 
         style="width:  100%; background-color: #fff; border: 1px solid #888888;   border-radius: 5px 5px 0 0 !important; height:25px; line-height: 25px;margin-bottom: 10px;"
          v-model="registerInfoForm.company_email"         
          maxlength="64"        
        />
      </el-col>
    </el-row>                                                                              

      <el-row :gutter="10" class="mb8">
        <el-col :span="24" style="text-align: right;">
            <el-button type  = "normal" @click="refreshPage">取消</el-button>
            <el-button type="primary" @click="submit_email">提交</el-button>

        </el-col>
      </el-row>
  </el-form>
</el-dialog>  

  <!-- 设置发票相关对话框 -->
 <el-dialog title="设置发票相关信息" :visible.sync="open_invoice_related_setting" width="800px" append-to-body @close="open_admin_name_setting= false">
  <el-form ref="register_info_changeFormRef" :model="register_info_changeForm" label-width="150px">
    <el-row :gutter="10" class="mb8">
      <el-col :span="12">
        <el-form-item label="开户行">
          <input 
         style="width:  100%; background-color: #fff; border: 1px solid #888888;   border-radius: 5px 5px 0 0 !important; height:25px; line-height: 25px;margin-bottom: 10px;"
          v-model="registerInfoForm.bank_name"         
          maxlength="50"/>    
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="银行账号">
          <input 
         style="width:  100%; background-color: #fff; border: 1px solid #888888;   border-radius: 5px 5px 0 0 !important; height:25px; line-height: 25px;margin-bottom: 10px;"
          v-model="registerInfoForm.bank_account"         
          maxlength="50"/>    
        </el-form-item>
      </el-col>
    </el-row>        
    <el-row :gutter="10" class="mb8">
      <el-col :span="12">
        <el-form-item label="注册地址">
          <input 
         style="width:  100%; background-color: #fff; border: 1px solid #888888;   border-radius: 5px 5px 0 0 !important; height:25px; line-height: 25px;margin-bottom: 10px;"
          v-model="registerInfoForm.reg_address"         
          maxlength="200"/>    
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="企业电话">
          <input 
         style="width:  100%; background-color: #fff; border: 1px solid #888888;   border-radius: 5px 5px 0 0 !important; height:25px; line-height: 25px;margin-bottom: 10px;"
          v-model="registerInfoForm.company_phone"         
          maxlength="20"/>    
        </el-form-item>
      </el-col>
    </el-row>                                                                              

      <el-row :gutter="10" class="mb8">
        <el-col :span="24" style="text-align: right;">
          <el-button type="primary" @click="submit_invoice_related">提交</el-button>
            <el-button type  = "normal" @click="refreshPage">取消</el-button>


        </el-col>
      </el-row>
  </el-form>
</el-dialog>  
  </div>
</template>

<script>
import { getTenantinfo } from '@/api/tenant/tenant'
import {postAicsUsage, postAdminName, postEmail, postInvoiceRelated} from '@/api/auth/account_setting';
  import { mapState } from 'vuex';
  import LicenceUploader from '@/components/LicenceUploader.vue'
  import { postAuthenticationChange } from '@/api/auth/authentication'
  import {save_log} from '@/api/tenant/TenantOperationLogs'
  import { send_sms_code } from '@/api/common'
  import { change_admin} from '@/api/auth/user'
  import { mapActions } from 'vuex'
export default {
  name: 'accountSetting',
  components:{
    LicenceUploader
  },
  data() {
    return {
      // 列表数据
      loading: false,    
      loading_sms: false, // 加载状态
      countdown: 0,   //发送短信倒计时
      
      registerInfoForm:null,
      open_change_register_info: false, //打开资质变更弹框
      register_info_changeForm:{
        org_type: '1',
        company_name: '',        
          nickName: '',
         social_credit_code: '',
        contact_person: '',
        contact_phone: '',
        code: '',
        aicsUsage: '',
        licenceFile: null,
        // ========== 新增字段 ==========
        license_url: '',
        bank_name: '',
        bank_account: '',
        reg_address: '',
        company_phone: '', 
    
    },      
          changeAdminForm: {
        username: '',
        code1: '',
        code2: '',
        newPhone: '',
        newName: '',
      },
    open_aics_usage: false,
    open_admin_name_setting: false,  //设置租户管理员姓名
    dialogChangeAdminVisible: false,  // 变更管理员
    open_admin_email_setting: false,  //设置企业邮箱姓名
    open_invoice_related_setting: false,  //设置企业邮箱姓名
    }     
  },
      computed: {
        ...mapState('auth', ['tenantInfo', 'userInfo']),
      },
  mounted() {
    console.log("userInfo", this.userInfo)
if(this.tenantInfo && this.tenantInfo.status && this.tenantInfo.status.trim()!=='APPROVED'){
    this.$message.error('租户状态未激活');  
    this.logout();
}     
        console.log("tenantInfo", this.tenantInfo)
        getTenantinfo(this.tenantInfo?.tenantId).then(res => {
         console.log("getTenantinfo res:", res);
         this.checkCountdown();
         this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.userInfo.username);
        if(res.data.code === 200) {
          // 使用Vue.set确保响应式
          this.$set(this, 'registerInfoForm', res.data.data);
          this.registerInfoForm = res.data.data
          console.log('this.registerInfoForm:', this.registerInfoForm);          

          // 初始化变更表单，确保每个字段都有初始值
          this.$set(this, 'register_info_changeForm', {
            org_type: this.registerInfoForm.org_type || '',
            company_name: this.registerInfoForm.company_name || '',
            social_credit_code: this.registerInfoForm.social_credit_code || '',
            contact_person: this.registerInfoForm.contact_person || '',
            contact_phone: this.registerInfoForm.contact_phone || '',
            bank_name: this.registerInfoForm.bank_name || '',
            bank_account: this.registerInfoForm.bank_account || '',
            reg_address: this.registerInfoForm.reg_address || '',
            company_phone: this.registerInfoForm.company_phone || '',
            licenceFile: null,
            license_url: this.registerInfoForm.license_url || ''
          });  
      
          console.log("register_info_changeForm", this.register_info_changeForm);
         // 初始化资质证明预览（从已有数据加载）
        if (this.registerInfoForm?.license_url) {
          this.licensePreviewImage = this.registerInfoForm.license_url    }
     
        }
        this.$nextTick(() => {
          this.HandleOrgTypeChange(this.registerInfoForm.org_type || 1);
        });     
        });
  },
  methods: {  
    ...mapActions('auth', ['logout']), // ogout action

    refreshPage() {
    location.reload()
  },
    // 统一的时间格式化方法
    formatDateTime(dateTime) {
      if (!dateTime) return '-'
      
      // 处理数组格式 [year, month, day, hour, minute, second]
      if (Array.isArray(dateTime)) {
        try {
          const year = dateTime[0]
          const month = String(dateTime[1]).padStart(2, '0')
          const day = String(dateTime[2]).padStart(2, '0')
          const hour = String(dateTime[3] || 0).padStart(2, '0')
          const minute = String(dateTime[4] || 0).padStart(2, '0')
          
          return `${year}-${month}-${day} ${hour}:${minute}`
        } catch (e) {
          console.error('日期格式化错误:', e)
          return String(dateTime)
        }
      }
      
      // 处理字符串格式
      if (typeof dateTime === 'string') {
        // 去掉 'T' 和毫秒
        return dateTime.replace('T', ' ').substring(0, 16)
      }
      
      return String(dateTime)
    },    

    // 工具方法
    formatTime(time) {
      if (!time) return '-'
      return new Date(time).toLocaleString('zh-CN')
    },        
   

    getOrgTypeStr(val){
        if(val ===1)
        return '企业';
        if(val === 2)
        return '个体工商户'
        if(val === 3)
        return '政府与事业单位';
        if(val === 4)
        return '个体工商户';
        if(val === 5)
        return '个人开发者/创作者';
    },

    GetOrgLabel(org_type, label_type) {
    org_type = Number(org_type)
    if (!org_type || !label_type) return;
    const labels = {
        1: { name: '企业名称', code: '统一社会信用代码', pic: '营业执照照片/扫描件' },
        2: { name: '个体工商户名称', code: '统一社会信用代码', pic: '个体工商户营业执照' },
        3: { name: '政府与事业单位名称', code: '统一社会信用代码', pic: '统一社会信用代码证书/事业单位法人证书' },
        4: { name: '社会组织名称', code: '统一社会信用代码', pic: '社会组织登记证书/慈善组织公开募捐资格证书' },
        5: { name: '开发/创作者名称', code: '身份证号码', pic: '个人身份证件、辅助证明材料' }
    }
    const label = labels[org_type]
    let val  = "";
    if (label) {
        
        switch(label_type){
            case "name":
            val = label.name;
            break;
        case "code":
            val = label.code;
            break;
        case "pic":
            val = label.pic;
            break;          
         }     
        }
        return val;
    },
    onLicenceFileChange(file) {
        // file 可能是 File 或 null
        this.register_info_changeForm.licenceFile = file
      },

    HandleOrgTypeChange(val) {
    val = Number(val)
    if (!val) return
    const labels = {
        1: { name: '企业名称', code: '统一社会信用代码', pic: '营业执照照片/扫描件' },
        2: { name: '个体工商户名称', code: '统一社会信用代码', pic: '个体工商户营业执照' },
        3: { name: '政府与事业单位名称', code: '统一社会信用代码', pic: '统一社会信用代码证书/事业单位法人证书' },
        4: { name: '社会组织名称', code: '统一社会信用代码', pic: '社会组织登记证书/慈善组织公开募捐资格证书' },
        5: { name: '开发/创作者名称', code: '身份证号码', pic: '个人身份证件、辅助证明材料' }
    }
    const label = labels[val]
    if (label) {
        this.labelOrgNameText = label.name
        this.labelOrgCodeText = label.code
        this.labelOrgPicText = label.pic
    }
    },    
    change_register_info(){
             getTenantinfo(this.tenantInfo?.tenantId).then(res => {
         console.log("getTenantinfo res:", res);
        if(res.data.code === 200) {
          // 使用Vue.set确保响应式
          this.$set(this, 'registerInfoForm', res.data.data);
          this.registerInfoForm = res.data.data
          console.log('this.registerInfoForm:', this.registerInfoForm);          

          // 初始化变更表单，确保每个字段都有初始值
          this.$set(this, 'register_info_changeForm', {
            org_type: this.registerInfoForm.org_type || '',
            company_name: this.registerInfoForm.company_name || '',
            social_credit_code: this.registerInfoForm.social_credit_code || '',
            contact_person: this.registerInfoForm.contact_person || '',
            contact_phone: this.registerInfoForm.contact_phone || '',
            bank_name: this.registerInfoForm.bank_name || '',
            bank_account: this.registerInfoForm.bank_account || '',
            reg_address: this.registerInfoForm.reg_address || '',
            company_phone: this.registerInfoForm.company_phone || '',
            licenceFile: null,
            license_url: this.registerInfoForm.license_url || ''
          });  
      
          console.log("register_info_changeForm", this.register_info_changeForm);
         // 初始化资质证明预览（从已有数据加载）
        if (this.registerInfoForm?.license_url) {
          this.licensePreviewImage = this.registerInfoForm.license_url    }
     
        }
        this.$nextTick(() => {
          this.HandleOrgTypeChange(this.registerInfoForm.org_type || 1);
          this.open_change_register_info = true
        });     
        });
    },

        handleDialogClose() {
      this.register_info_changeForm.licenceFile = null
      this.licensePreviewImage = null
      if (this.$refs.licenceFile) {
        this.$refs.licenceFile.value = ''
      }
    },

 // 资质变更提交
    async submitregister_info_changeForm() {
      let response = null;
      this.loading_accountSetting_submit = true  // 复用加载状态
      try {
        const formData = new FormData();
        
        formData.append('tenant_id', this.tenantInfo?.tenantId);
        formData.append('company_name', this.register_info_changeForm.company_name);
        formData.append('social_credit_code', this.register_info_changeForm.social_credit_code);
        formData.append('org_type', this.register_info_changeForm.org_type);
        formData.append('contact_person', this.register_info_changeForm.contact_person);        
        if (this.register_info_changeForm.licenceFile) {
          formData.append('licenceFile', this.register_info_changeForm.licenceFile);
        }
        
        if (this.register_info_changeForm.bank_name) {
          formData.append('bank_name', this.register_info_changeForm.bank_name);
        }
        if (this.register_info_changeForm.bank_account) {
          formData.append('bank_account', this.register_info_changeForm.bank_account);
        }
        if (this.register_info_changeForm.reg_address) {
          formData.append('reg_address', this.register_info_changeForm.reg_address);
        }
        if (this.register_info_changeForm.company_phone) {
          formData.append('company_phone', this.register_info_changeForm.company_phone);
        }
        
        response = await postAuthenticationChange(formData);
        console.log("postAuthenticationChange", response);
        if (response.data.code == 200) {   // 记录日志
            const formDatalog = new FormData();
            formDatalog.append("operation_type", "USER_REGISTER_CHANGE_SUBMIT")
            formDatalog.append("operation_content", "资质变更请求已经提交。")
            save_log(
              {
                "operation_type": "USER_REGISTER_CHANGE_SUBMIT",
                "operation_content": "资质变更请求已经提交。"
              }
            );

          this.$message.success(response.data?.message || '提交成功');

       
          this.open_change_register_info = false;
        } else {
          this.$message.error(response.data?.message || '提交失败');
        }
      } catch (error) {
        console.error('提交变更资质失败:', error);
        this.$message.error(error.response?.data?.message || '提交失败');
      } finally {
        this.loading_accountSetting_submit = false
      }
    },  

         // 设置租户管理员姓名提交
    async submit_admin_name() {
        if(this.registerInfoForm.admin_name ===""){
        this.$message.error('请输入管理员姓名');
        return;
      }
      postAdminName(this.registerInfoForm).then(response => {
        console.log('postAdminName response', response);
        if (response && response.code === 200) {
          this.$message.success('设置租户管理员姓名成功');
          this.open_admin_name_setting = false; // 关闭对话框
        } else {
          this.$message.error('设置租户管理员姓名失败');
        }
      }).catch(error => {
        console.error('postAdminName error', error);
        this.$message.error('设置AI租户管理员姓名失败'+error);
      });
    },       
     // AI客服应用场景提交
    async submit_aics_usage() {
        if(this.registerInfoForm.aics_usage ===""){
        this.$message.error('请输入应用场景');
        return;
      }

      postAicsUsage(this.registerInfoForm).then(response => {
        console.log('postAicsUsage response', response);
        if (response && response.code === 200) {
          this.$message.success('设置AI客服应用场景成功');
          this.open_aics_usage = false; // 关闭对话框
        } else {
          this.$message.error('设置AI客服应用场景失败');
        }
      }).catch(error => {
        console.error('postAicsUsage error', error);
        this.$message.error('设置AI客服应用场景失败'+error);
      });
    },

    change_admin(){    
      console.log('change_admin',this.userInfo);
      this.changeAdminForm.username = this.userInfo.username;
      this.dialogChangeAdminVisible = true
    },    

        startCountdown() {
      this.countdown = 60;
      localStorage.setItem('smsCountdown', Date.now() + 60000); // 存储过期时间

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          localStorage.removeItem('smsCountdown');
        }
      }, 1000);
    },
    checkCountdown() {
      console.log('checkCountdown');
      const savedTime = localStorage.getItem('smsCountdown');
      console.log(savedTime);
      if (savedTime) {
        const remainingTime = Math.ceil((parseInt(savedTime) - Date.now()) / 1000);
        if (remainingTime > 0) {
          this.countdown = remainingTime;
          this.startCountdown();
        } else {
          localStorage.removeItem('smsCountdown');
        }
      }
    },
    async sendSMSCode_change_admin() {
      let phone = this.changeAdminForm.username+","+ this.changeAdminForm.newPhone;
      if (this.isCountingDown || !this.validatePhone(this.changeAdminForm.newPhone)) return;

      try {
        const response = await send_sms_code(phone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.startCountdown();
          this.$message.success('已经给2个手机号发送验证码，请分别填入对应手机号下面的验证码文本框');
          this.smsError = '';
        } else {
          this.$message.error((response.data && response.data.message) || '发送验证码失败');
        }
      } catch (error) {

        this.$message.error(error);
      }
    },    

    validatePhone(phone) {
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(phone)
      if (!this.isPhoneValid) {
        this.$message.error('请输入正确的手机号')
      }
      return this.isPhoneValid
    },  
    
    async handleChangeAdminSubmit() {
      if(this.changeAdminForm.code1===""){
        this.$message.error('请输入原手机验证码');
        return;
      }
      if(this.changeAdminForm.newPhone===""){
        this.$message.error('请输入新手机号码');
        return;
      }
      if(this.changeAdminForm.newPhone===this.changeAdminForm.username){
        this.$message.error('新手机号码不能与原手机号码相同');

        return;
      }
      if(this.changeAdminForm.code2===""){
        this.$message.error('请输入新手机验证码');
        return;
      }
      if(this.changeAdminForm.newName===""){
        this.$message.error('请输入新姓名');
        return;
      }
      console.log('changeAdminForm', this.changeAdminForm);
      change_admin(this.changeAdminForm).then(response => {
        console.log('change_admin response', response);
        if (response && response.code === 200) {
          this.$message.success('变更管理员成功,当前用户已经不能使用了，需要重新登录');
          this.dialogChangeAdminVisible = false; // 关闭对话框
          this.logout();
        } else {
          this.$message.error('变更管理员失败');
        }
      }).catch(error => {
        console.error('change_admin error', error);
        this.$message.error('变更管理员失败:'+error);
      });
    },

    handleleChangeAdminClose(){
      this.dialogChangeAdminVisible = false;
    },

    async logout() {
      try {
        // 调用 Vuex 中的 logout action
        await this.$store.dispatch('auth/logout')
        // 退出成功后跳转到登录页
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        // 即使退出API调用失败，也强制清除本地状态并跳转
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },

         // 设置租户管理员姓名提交
    async submit_email() {
        if(this.registerInfoForm.company_email ===""){
        this.$message.error('请输入企业邮箱');
        return;
      }
      postEmail(this.registerInfoForm).then(response => {
        console.log('postEmail response', response);
        if (response && response.code === 200) {
          this.$message.success('设置企业邮箱成功');
          this.open_admin_email_setting = false; // 关闭对话框
        } else {
          this.$message.error('设置企业邮箱失败');
        }
      }).catch(error => {
        console.error('postEmail error', error);
        this.$message.error('设置企业邮箱失败'+error);
      });
    },    
    
    // 设置发票相关信息提交
    async submit_invoice_related() {
        if(this.registerInfoForm.bank_name ===""){
        this.$message.error('请输入开户行');
        return;
      }
      if(this.registerInfoForm.bank_account ===""){
        this.$message.error('请输入银行账号');
        return;
      }
        if(this.registerInfoForm.reg_address ===""){
        this.$message.error('请输入注册地址');
        return;
      }
      if(this.registerInfoForm.company_phone ===""){
        this.$message.error('请输入企业电话');
        return;
      }      
      postInvoiceRelated(this.registerInfoForm).then(response => {
        console.log('postInvoiceRelated response', response);
        if (response && response.code === 200) {
          this.$message.success('设置发票相关信息成功');
          this.open_invoice_related_setting = false; // 关闭对话框
        } else {
          this.$message.error('设置发票相关信息失败');
        }
      }).catch(error => {
        console.error('postInvoiceRelated error', error);
        this.$message.error('设置发票相关信息失败'+error);
      });
    },       

  }
}
</script>

<style lang="scss" scoped>
.setting-container {
  padding: 24px;
  max-width: 1100px;
  margin: 0 auto;
  background: #f5f7fa;
  min-height: 100vh;
}

.setting-header {
  margin-bottom: 24px;

  .page-title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #1a1a2e;
  }
}

/* 主面板容器：flex 两栏布局 */
.info-panels {
  display: grid;
  grid-template-columns: 1fr 1fr;  /* 两列等宽 */
  gap: 24px;
  margin-bottom: 32px;
}

/* 公共面板样式 */
.panel {
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

/* 字段行 */
.field {
  display: flex;
  align-items: flex-start;
  padding: 10px 0;
  border-bottom: 1px solid #f0f2f5;

  &:last-child {
    border-bottom: none;
  }
}

.field-title {
  flex-shrink: 0;
  width: 110px;
  font-size: 14px;
  color: #606266;
  text-align: right;
  padding-right: 12px;
  font-weight: 450;
  line-height: 28px;
}

.field-value {
  flex: 1;
  font-size: 10pt;
  color: #303133;
  line-height: 28px;
  word-break: break-all;
}

/* 底部面板：发票信息 */
.bottom-panel {
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .el-divider {
    margin-top: 0;
  }

  .el-divider__text {
    font-size: 15px;
    font-weight: 550;
    color: #1a1a2e;
  }
}

/* 发票字段网格布局 */
.invoice-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4px 40px;
  padding-top: 8px;

  .field {
    border-bottom: none;
    padding: 6px 0;
  }

  .field-title {
    width: 90px;
  }
}

/* 右侧图片适应 */
#right_panel .field img {
  max-width: 260px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
}

/* 小屏适配 */
@media screen and (max-width: 768px) {
.info-panels {
  display: flex;
  gap: 24px;
  margin-bottom: 32px;
}

.panel {
  flex: 1;  /* 两个面板各占一半 */
  background: #ffffff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 20px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  /* 可选：设置最小宽度防止过窄 */
  min-width: 500px;
}

  .invoice-grid {
    grid-template-columns: 1fr;
  }

  .field-title {
    width: 100px;
  }
}
.btn-primary {
  background-color: var(--primary-color, #057FDB);
  color: white;
  cursor: pointer;
  padding: 2px 5px 2px 5px;
  margin-left: 10px;
}

.inputbox{
  border: 1px solid #474747;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12pt;
  margin-left: 10px; 
}
</style>